module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-5.811220c6.jpeg";